export function initTrackingEvents() {
  initCustomEventHandler();
}

/**
 * Dispatches event for actions on website
 * @param details
 * @param element which element that sends event
 */
export function dispatchTrackEvent(details, element = document) {
  element.dispatchEvent(new CustomEvent('sail_track', {
    detail: details,
    bubbles: true,
    cancelable: false,
  }));
}

/**
 * Handles custom events
 * Pushes details to GA
 */
function initCustomEventHandler() {
  window.addEventListener('sail_track', (event) => {
    if (!event.detail.eventCategory) return;
    if (!event.detail.eventAction) return;
    if (!event.detail.eventValue) return;

    pushGAEvent({
      'event': 'GAEvent',
      'eventCategory': event.detail.eventCategory,
      'eventAction': event.detail.eventAction,
      'eventLabel': event.detail.eventLabel,
      'eventValue': event.detail.eventValue,
      'nonInteraction': event.detail.nonInteraction,
    });
  });
}

/**
 * Updates DataLayer
 * @param props
 */
function pushGAEvent(props) {
  if (!props) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(props);
}
